import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

const CopyrightFooter = ({copyrightText}) => {
  const {
    footer_text: copyright,
    technical_manager: technicalManager,
  } = copyrightText
  return (
    <S.CopyrightFooterContainer data-testid='footer-copyright'>
      <S.CopyrightText data-testid='text-copyright'>{copyright}</S.CopyrightText>
      <S.CopyrightCRM data-testid='crm-copyright'>{technicalManager}</S.CopyrightCRM>
    </S.CopyrightFooterContainer>
  )
}

CopyrightFooter.propTypes = {
  copyrightText: PropTypes.object
}

export default CopyrightFooter
